import { AssistanceStatus } from './assistanceStatus'
import { FeathersModel } from './feathersModel'

export class CalendarWorkerAvailabilityAssistanceAssistantAssignment {
  id: number
  assistantId: number
  assistanceId: number
  status: AssistanceStatus
}

export class CalendarWorkerAvailabilityAssistance extends FeathersModel {
  static serviceName = 'features/worker-availabilities-calendar/assistances'

  id: number

  // Start and end
  realizedFrom: Date
  realizedTo: Date
  plannedFrom: Date
  plannedTo: Date

  // Extended information
  clientFullName: string
  addressStart: string
  addressEnd: string

  // Light-weight assistant assignments
  assistantAssignments: CalendarWorkerAvailabilityAssistanceAssistantAssignment[] = []

  getStart(): Date {
    if (this.realizedFrom) {
      return new Date(this.realizedFrom)
    } else if (this.plannedFrom) {
      return new Date(this.plannedFrom)
    } else {
      throw new Error('Start date cannot be constructed')
    }
  }

  getEnd(): Date {
    if (this.realizedTo) {
      return new Date(this.realizedTo)
    } else if (this.plannedTo) {
      return new Date(this.plannedTo)
    } else {
      throw new Error('End date cannot be constructed')
    }
  }
}
